import { Tooltip } from 'bootstrap'

function uploadTooltip() {
  setTimeout( () => {
    Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach(node => new Tooltip(node))
  }, 1000 )
}

function removeTooltip() {
  Array.from(document.querySelectorAll('[role="tooltip"]')).forEach(node => node.remove())
}

export { uploadTooltip, removeTooltip }
